import { Component, Mixins } from 'vue-property-decorator';
import { StringsMixin } from './StringsMixin';
import { US_STATES } from '@/../types/constants/us-states';
import { CA_PROVINCES } from '@/../types/constants/ca-provinces';
import { ALL_COUNTRIES } from '@/../types/constants/countries';
import { GenderValues } from '@best-athletes/ba-types';

@Component
export class FormMixin extends Mixins(StringsMixin) {
    US_STATES = US_STATES;
    CA_PROVINCES = CA_PROVINCES;
    COUNTRIES = ALL_COUNTRIES;
    GENDERS = GenderValues;

    requiredFields: Array<string> = [
        'First Name', 'Last Name', 'email', 
        'Address', 'City', 'State', 'Province', 'Country', 'Zip Code', 'Postal Code',
        'Phone Number', 'Cell Phone', 'Cell Number', 'Mobile Phone',
        'Birth Date', 'Date of Birth', 'DoB', 'Height', 'Weight', 'Height ft in', 'Weight lbs', 'Height cm', 'Weight kg',
        'USA Rugby ID Number', 'Graduation Year', 'GPA', 'Gender', 'Team Gender', 'Grade', 
        'Primary Position 15s', 'Secondary Position 15s', 'Primary Position 7s', 'Secondary Position 7s',
        'Guardian', 'Emergency', 'Medical',
    ];
    unrequiredFields: Array<string> = [
        'Address 2', 'Coach Email',
    ]
    requiredFieldMissing: string;
    requiredFieldMisformed: string;
    isMissingRequiredData: boolean = false;
    IsRequiredField(field: string, data:Record<string,any>) {
        if( this.IsEmpty(field) ) return false;
        if( this.IsEmpty(this.requiredFields) ) return false;

        const normField = this.NormalizeString(field);
        if( this.IsEmpty(normField) ) return false;

        if( this.IsNotEmpty(this.unrequiredFields) ) {
            const unrequiredNorms = this.unrequiredFields.map(f => this.NormalizeString(f));
            if( unrequiredNorms.some(f => normField.includes(f)) ) return false;
        }

        const requiredNorms = this.requiredFields.map(f => this.NormalizeString(f));
        const isNotRequired = requiredNorms.findIndex(f => normField === f) < 0;
        if( isNotRequired ) return false;

        const dataNorms = Object.entries(data).reduce((acc, [key, value]) => {
            acc[this.NormalizeString(key)] = value;
            return acc;
        }, {});        
        return this.IsEmpty(data[field]) && this.IsEmpty(dataNorms[normField]);
    }

    IsLabelTextArea(label: string): boolean {
        return this.NormStringIncludes(label, 'comment');
    }
    IsLabelDate(label: string): boolean {
        return this.NormStringIncludes(label, 'date');
    }
    IsLabelBirth(label: string): boolean {
        return this.NormStringIncludes(label, 'birth');
    }
    IsLabelState(label: string): boolean {
        return this.NormStringIncludes(label, 'state');
    }
    IsLabelProvince(label: string): boolean {
        return this.NormStringIncludes(label, 'province');
    }
    IsLabelCountry(label: string): boolean {
        return this.NormStringIncludes(label, 'country');
    }
    IsLabelGender(label: string): boolean {
        return this.NormStringIncludes(label, 'gender');
    }
    IsLabelGrade(label: string): boolean {
        return this.NormStringIncludes(label, 'grade');
    }
    IsLabelHeightFtIn(label: string): boolean {
        return this.NormStringIncludes(label, 'height ft in');
    }
    IsLabelWeight(label: string): boolean {
        return this.NormStringIncludes(label, 'weight');
    }
    IsLabelSize(label: string): boolean {
        return this.NormStringIncludes(label, 'size');
    }

    // Rugby
    IsLabelRugbyPosition15(label: string): boolean {
        return this.NormStringIncludes(label, 'position 15');
    }
    IsLabelRugbyPosition7(label: string): boolean {
        return this.NormStringIncludes(label, 'position 7');
    }

    LabelColumnSize(label: string): number {
		const longFields = ['email','address','date','dob'];
		const shortFields = ['gender','size','weight','height','grade','graduation','gpa','sat'];
		if( longFields.some(f => this.NormStringIncludes(label, f))) return 12;
		if( shortFields.some(f => this.NormStringIncludes(label, f))) return 4;
        if( this.IsLabelTextArea(label) ) return 12;
        return 6;
    }
}
